// Utilities
import { loadScript } from '../utils/widget';
import { isValidString } from '../utils/helper';


class TawkMessenger {
	constructor(root, options) {
		if (!isValidString(options.propertyId)) {
			return;
		}

		if (!isValidString(options.widgetId)) {
			return;
		}
		
		this.root = root;
		this.propertyId = options.propertyId;
		this.widgetId = options.widgetId;
		this.embedId = options.embedId;
		this.customStyle = options.customStyle;

		this.load();
	}

	load() {
		if (!window || !document) {
			return;
		}
		
		/**
		 * Set placeholder
		 */
		window.Tawk_API = window.Tawk_API || {};
		window.Tawk_LoadStart = new Date();

		/**
		 * Inject the Tawk script
		 */
		loadScript({
			propertyId : this.propertyId,
			widgetId : this.widgetId,
			embedId : this.embedId
		});

		this.init();
	}

	init() {
		if (this.customStyle && typeof this.customStyle === 'object') {
			window.Tawk_API.customStyle = this.customStyle;
		}

		/**
		 * Map the APIs
		 */
		this.mapActions();
		this.mapGetters();
		this.mapListeners();
		this.mapSetters();
	}

	/**
	 * API for calling an action on the widget
	 */
	mapActions() {
		this.root.maximize = () => window.Tawk_API.maximize();
		this.root.minimize = () => window.Tawk_API.minimize();
		this.root.toggle = () => window.Tawk_API.toggle();
		this.root.popup = () => window.Tawk_API.popup();
		this.root.showWidget = () => window.Tawk_API.showWidget();
		this.root.hideWidget = () => window.Tawk_API.hideWidget();
		this.root.toggleVisibility = () => window.Tawk_API.toggleVisibility();
		this.root.endChat = () => window.Tawk_API.endChat();
	}

	/**
	 * API for returning a data
	 */	
	mapGetters() {
		this.root.getWindowType = () => window.Tawk_API.getWindowType();
		this.root.getStatus = () => window.Tawk_API.getStatus();
		this.root.isChatMaximized = () => window.Tawk_API.isChatMaximized();
		this.root.isChatMinimized = () => window.Tawk_API.isChatMinimized();
		this.root.isChatHidden = () => window.Tawk_API.isChatHidden();
		this.root.isChatOngoing = () => window.Tawk_API.isChatOngoing();
		this.root.isVisitorEngaged = () => window.Tawk_API.isVisitorEngaged();
		this.root.onLoaded = () => window.Tawk_API.onLoaded;
		this.root.onBeforeLoaded = () => window.Tawk_API.onBeforeLoaded;
		this.root.widgetPosition = () => window.Tawk_API.widgetPosition();
	}

	/**
	 * API for listening an event emitting
	 * inside of the widget
	 */
	mapListeners() {
		window.addEventListener('tawkLoad', () => {
		});

		window.addEventListener('tawkStatusChange', (status) => {
		});

		window.addEventListener('tawkBeforeLoad', () => {
			window.Tawk_API.hideWidget()
		});

		window.addEventListener('tawkChatMaximized', () => {
		});

		window.addEventListener('tawkChatMinimized', () => {
		});

		window.addEventListener('tawkChatHidden', () => {
			
		});

		window.addEventListener('tawkChatStarted', () => {
		});

		window.addEventListener('tawkChatEnded', () => {
		});

		window.addEventListener('tawkPrechatSubmit', (data) => {
		});

		window.addEventListener('tawkOfflineSubmit', (data) => {
		});
		
		window.addEventListener('tawkChatMessageVisitor', (message) => {
		});

		window.addEventListener('tawkChatMessageAgent', (message) => {
		});

		window.addEventListener('tawkChatMessageSystem', (message) => {
		});

		window.addEventListener('tawkAgentJoinChat', (data) => {
		});
		
		window.addEventListener('tawkAgentLeaveChat', (data) => {
		});

		window.addEventListener('tawkChatSatisfaction', (satisfaction) => {
		});
		
		window.addEventListener('tawkVisitorNameChanged', (visitorName) => {
		});

		window.addEventListener('tawkFileUpload', (link) => {
		});

		window.addEventListener('tawkTagsUpdated', (data) => {
		});

		window.addEventListener('tawkUnreadCountChanged', (data) => {
		});
	}

	/**
	 * API for setting a data on the widget
	 */
	mapSetters() {
		this.root.visitor = (data) => window.Tawk_API.visitor = data;
		this.root.setAttributes = (attribute, callback) => window.Tawk_API.setAttributes(attribute, callback);
		this.root.addEvent = (event, metadata, callback) => window.Tawk_API.addEvent(event, metadata, callback);
		this.root.addTags = (tags, callback) => window.Tawk_API.addTags(tags, callback);
		this.root.removeTags = (tags, callback) => window.Tawk_API.removeTags(tags, callback);
	}
}


export default TawkMessenger;